import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {getFormSyncErrors, getFormValues} from 'redux-form'
import * as jobActions from '../../actions/jobActions';
import * as contactPersonListActions from '../../actions/contactPersonListActions';
import * as contactPersonModalActions from '../../actions/contactPersonModalActions';
import * as pendingPageActions from "../../actions/pendingPageActions";
import * as submitButtonActions from '../../actions/submit/submitButtonActions';
import * as modalActions from '../../actions/common/modalActions';
import JobsForm from './JobsForm';
import JobViewPage from './view/JobViewPage';
import ContactPersonModal from '../contact-person/ContactPersonModal';
import PreviewModal from '../common/PreviewModal';
import { FormattedMessage, injectIntl } from 'react-intl';
import {messages} from  '../common/Translations';
import WithResolvedPromises from "../common/WithResolvedPromises";
import Placeholder from "../Placeholder";
import PlaceholderError from "../common/PlaceholderError";
import ResetFormModal from "../ResetFormModal";

class JobsFormContainer extends React.Component {
    constructor(props) {
        super(props);

        // set id from url
        this.jobId = props.match.params.id;
        this.actions = this.getRequiredActions();
    }

    getRequiredActions() {
        let actions = [
            this.props.actions.loadContactPersons(this.props.user.company.id),
            this.props.actions.loadJobRegions(),
            this.props.actions.loadJobCategories(),
            this.props.actions.loadJobWorkingTimes(),
        ];

        if(this.jobId) {
            actions.push(this.props.actions.getJob(this.jobId));
        }

        return actions;
    }

    componentWillReceiveProps(newProps) {
        if(Object.keys(newProps.errors).length !== 0 && newProps.showJobPreviewModal) {
            newProps.actions.showSweetAlertModal(this.props.intl.formatMessage(messages.mustFillRequiredFields));
            newProps.actions.hidePreviewModal();
        }
    }

    onModalClick() {
        this.props.actions.showContactPersonModal();
    }

    submit(formFields) {
        let formatedFields = Object.assign({}, formFields);
        formatedFields.isCommentsAllowed = formatedFields.isCommentsAllowed || false;
        formatedFields.status = formatedFields.status ? parseInt(formatedFields.status) : 1;
        formatedFields.categoryId = formatedFields.categoryId[0];

        if(!this.jobId) {
            this.props.actions.createJob(formatedFields).then(() => {
                this.redirect();
            });
        } else {
            this.props.actions.updateJob(this.jobId, formatedFields).then(() => {
                this.redirect();
            });
        }
    }

    confirmReset() {
        this.props.actions.hideResetFormModal();
        this.redirect();
    }

    handleReset() {
        this.props.actions.showResetFormModal();
    }

    redirect() {
        this.context.router.history.push('/jobopslag');
    }

    getPreviewModalContent() {
        let {
            formValues,
            job,
            user,
            errors,
            jobRegions,
            jobCategories,
            jobWorkingTimes,
        } = this.props;

        // if form not ready yet or we don't need to load modal yet
        if(!Object.keys(formValues).length || !this.props.showJobPreviewModal || Object.keys(errors).length) {
            return null;
        }

        let logoUrl = null;
        if(user.company.image) {
            logoUrl = user.company.image.path;
        }

        return <JobViewPage
            job={{
                companyName: job.companyName || user.company.name,
                title: formValues.title,
                logoUrl: job.logoUrl || logoUrl,
                content: formValues.content,
                region: jobRegions.find(region => region.id == formValues.regionId).value,
                category: jobCategories.find(category => category.id == formValues.categoryId).value,
                workingTime: jobWorkingTimes.find(workingTime => workingTime.id == formValues.workingTimeId).value,
                created: job.created,
            }}
        />;
    }

    render() {
        let {jobRegions, jobCategories, jobWorkingTimes, job, contactPersons} = this.props;

        return (
            <WithResolvedPromises preloaderComponent={Placeholder} promises={this.actions} errorComponent={PlaceholderError}>
              <div>
                <div className="row">
                    <div className="col-12">
                        <div className="card m-b-20">
                            <div className="card-block">
                                <h1 className="mb-3">{(!this.jobId
                                        ? this.props.intl.formatMessage(messages.jobCreate)
                                        : this.props.intl.formatMessage(messages.jobUpdate)
                                )}</h1>
                                <JobsForm
                                    initialValues={job}
                                    regions={jobRegions}
                                    categories={jobCategories}
                                    workingTimes={jobWorkingTimes}
                                    contactPersons={contactPersons}
                                    handleModalClick={this.onModalClick.bind(this)}
                                    onSubmit={this.submit.bind(this)}
                                    handleReset={this.handleReset.bind(this)}
                                    showJobPreviewModal={this.props.actions.showPreviewModal}
                                    isUpdate={this.jobId}
                                />
                                <ContactPersonModal/>
                            </div>
                        </div>
                    </div>
                </div>
                <PreviewModal>
                    {this.getPreviewModalContent()}
                </PreviewModal>
                  <ResetFormModal
                      modalTitle={this.props.intl.formatMessage(messages.resetModalTitle)}
                      modalContent={
                          <p>
                              <FormattedMessage
                                  id="reset.modal.message"
                                  defaultMessage="Are you sure, you want to cancel? All of your alterations will be lost."
                              />
                          </p>}
                      confirmText={this.props.intl.formatMessage(messages.buttonYes)}
                      closeText={this.props.intl.formatMessage(messages.buttonNo)}
                      handleConfirm={() => {this.confirmReset()}}
                  />
              </div>
            </WithResolvedPromises>

        )
    }
}


function mapStateToProps(state, ownProps) {

    let job =  Object.assign({}, state.job);
    let jobCategories = state.jobCategories || [];

    if(state.jobRegions.length && !(job.regionId && state.jobRegions.find(region => region.id == job.regionId))) {
        job.regionId = state.jobRegions[0]['id'];
    }

    if(state.jobWorkingTimes.length && !(job.workingTimeId && state.jobWorkingTimes.find(workingTime => workingTime.id == job.workingTimeId))) {
        job.workingTimeId = state.jobWorkingTimes[0]['id'];
    }

    let errors = Object.assign({}, getFormSyncErrors('job')(state));
    let formValues = Object.assign({}, getFormValues('job')(state));

    let categories = [];
    if(!Array.isArray(job.categoryId)) {
        const tmpValue = job.categoryId;
        if(jobCategories.indexOf(tmpValue) > -1) {
            categories = [tmpValue];
        }
    }

    job.categoryId = categories;

    return {
        user: state.user,
        jobRegions: state.jobRegions,
        jobCategories,
        jobWorkingTimes: state.jobWorkingTimes,
        contactPersons: state.contactPersons,
        job: job,
        formValues: formValues,
        errors: errors,
        showJobPreviewModal: state.showPreviewModal,
    }
}

JobsFormContainer.contextTypes = {
    router: PropTypes.object.isRequired
};

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(
            Object.assign(
                {},
                jobActions,
                contactPersonListActions,
                contactPersonModalActions,
                pendingPageActions,
                modalActions,
                submitButtonActions
            ), dispatch)
    }
}

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(JobsFormContainer));


// WEBPACK FOOTER //
// ./web/src/components/jobs/JobsFormContainer.jsx